import type { FC } from 'react';
import { Typography } from '@interstate/components/Typography';
import { Box } from '@interstate/components/Box';
import { CheckBox } from '@interstate/components/CheckBox';
import { COMPONENT_ID, TEMPLATE_ALWAYS_SAVED_V2, TEMPLATE_NEVER_SAVED_V2 } from './constants';

export type TemplateSaveStatusDialogV2ContentProps = {
    savePaymentTerms: boolean;
    toggleSavePaymentTerms: () => void;
};

const TemplateSaveStatusDialogV2Content: FC<TemplateSaveStatusDialogV2ContentProps> = ({
    savePaymentTerms,
    toggleSavePaymentTerms
}) => {
    return (
        <>
            <Box>
                <Typography variant="h4">Always Saved:</Typography>
                {TEMPLATE_ALWAYS_SAVED_V2.map((item, index) => (
                    <Typography key={index} variant="list-md">
                        {item}
                    </Typography>
                ))}
            </Box>
            <Box mt={2}>
                <Typography variant="h4">Never Saved:</Typography>
                {TEMPLATE_NEVER_SAVED_V2.map((item, index) => (
                    <Typography key={index} variant="list-md">
                        {item}
                    </Typography>
                ))}
            </Box>
            <Box
                mt={2}
                mb={2}
                sx={{ borderBottom: '1px solid', borderColor: 'sem.color.border.muted' }}
                data-testid={`${COMPONENT_ID}-divider`}
            />
            <Box>
                <Typography variant="h4">Optional Save:</Typography>
            </Box>
            <Box
                onClick={toggleSavePaymentTerms}
                mt={2}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                width="fit-content"
                sx={{ cursor: 'pointer' }}
            >
                <CheckBox
                    checked={savePaymentTerms}
                    value="include-payment-terms-checkbox"
                    data-testid={`${COMPONENT_ID}-payment-terms-checkbox`}
                />
                <Typography variant="body-md" sx={{ ml: 1 }}>
                    Save finance/lease terms
                </Typography>
            </Box>
            <Box mt={1}>
                <Typography variant="body-md" data-testid={`${COMPONENT_ID}-checkbox-hint`}>
                    When checked, applies to all scenarios in this template.
                </Typography>
                <Box mt={2}>
                    <Typography variant="body-md" data-testid={`${COMPONENT_ID}-checkbox-conditional-text`}>
                        {savePaymentTerms
                            ? 'Cash Down/Down Payment, Term, Mileage (for Lease), APR (for Finance) / Money Factor (for Lease), and Payment Grid will be saved.'
                            : 'System defaults will be used for finance/lease terms.'}
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export default TemplateSaveStatusDialogV2Content;
